export default {
  props: {
    intervention: {
      type: Object,
      required: true,
    },
	},
	methods: {
		save(){}
	}
};
